import { useParams } from 'react-router-dom'
import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import Button from 'shared/Buttons/Button/Button'
import ThreeDotsLoader from 'shared/Loaders/ThreeDotsLoader'
import { useEffect, useState } from 'react'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import eventBus from 'services/eventBus'
import { useSetRecoilState } from 'recoil'
import recoilStateUpdaters from 'recoil/recoil.stateUpdaters'
import useProjectTechnology from '../../hooks/useProjectTechnology'
import projectTechnologiesTableAtom from '../../componenets/ProjectTechnologiesTable/projectTechnologiesTable.atom'
import projectTechnologiesApi from '../../projectTechnologies.api'
import ProjectTechnologySheet from '../../componenets/ProjectTechnologySheet'

const ProjectTechnologyPage = () => {
  const { wait, loading: updateLoading } = useHttpLoader()

  const params = useParams()
  const id = +params.id
  const { technology, loading } = useProjectTechnology(id)
  const [draft, setDraft] = useState(technology)
  const setState = useSetRecoilState(projectTechnologiesTableAtom)

  useEffect(() => {
    setDraft(technology)
  }, [technology])

  const handleChange = (val: any, name: string) => {
    setDraft((prev) => ({ ...prev, [name]: val }))
  }

  const handleSave = () => {
    wait(projectTechnologiesApi.update(draft, id), (resp) => {
      if (resp.status === 'success') {
        recoilStateUpdaters.itemUpdated(setState, resp.body)
        eventBus.pub('ntf.message', { type: 'info', message: 'Технология обновлена' })
      }
    })
  }

  const renderContent = () => {
    if (!draft || loading) {
      return (
        <div className='flex-page-center'>
          <ThreeDotsLoader />
        </div>
      )
    }

    return (
      <>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Ключевая технология</h2>
          </div>
        </div>
        <ProjectTechnologySheet technology={draft} onChange={handleChange}>
          <Button theme='primary' loading={updateLoading} style={{ width: 'fit-content' }} onClick={handleSave}>
            Сохранить
          </Button>
        </ProjectTechnologySheet>
      </>
    )
  }

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>{renderContent()}</TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default ProjectTechnologyPage
